import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { Button, ButtonTheme } from '@apply/components';
import { useAuthentication } from '../../../../../../../../../../Login/hooks/useAuthentication';

interface DisabledRequestDrawButtonProps {
    dashboardDrawBudget: IDashboardDrawBudget;
}
export const DisabledRequestDrawButton: React.FC<DisabledRequestDrawButtonProps> = ({ dashboardDrawBudget }) => {
    const { authentication } = useAuthentication();
    const { isGeneralContractor } = authentication?.user || {};

    const buttonText =
        isGeneralContractor &&
        !dashboardDrawBudget.borrowerSubmitted &&
        dashboardDrawBudget.generalContractorSignatureRequiresApproval
            ? 'Pending Borrower'
            : 'Draw Pending';

    return (
        <Button
            id='secondaryButton'
            theme={ButtonTheme.Secondary}
            width='160px'
            disabled={true}
        >
            {buttonText}
        </Button>
    );
};
